import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBackward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBackward"><Path fillRule="evenodd" clipRule="evenodd" d="M21.9994 4H5.41909L0.847656 12L5.41909 20H21.9994V4ZM11 8.58579L9.58579 10L11.5858 12L9.58579 14L11 15.4142L13 13.4142L15 15.4142L16.4142 14L14.4142 12L16.4142 10L15 8.58579L13 10.5858L11 8.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBackward;
